import { put, takeEvery } from "@redux-saga/core/effects";
import {
	handleNotificationAlertCatch,
	handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";
import AxiosCustom from "../../../common/components/apiConfig";

export const actionTypes = {
	selectDebtTransfers: "[selectDebtTransfers] Action",
	selectDebtTransfersLoad: "[selectDebtTransfersLoad] Action",
	selectDebtTransfersAsync: "[selectDebtTransfersAsync] Action",
};

const initialState = {
	data: [],
	loading: false,
};

export const select_debt_transfers_reducer = (
	state = initialState,
	{ type, payload },
) => {
	switch (type) {
		case actionTypes.selectDebtTransfers:
			return {
				...state,
				data: payload?.data?.results ? payload?.data?.results : [],
			};

		case actionTypes.selectDebtTransfersLoad:
			return {
				...state,
				loading: payload,
			};
		default:
			return state;
	}
};

function* handleWorker({ payload }) {
	yield put({ type: actionTypes.selectDebtTransfersLoad, payload: payload });
	let config = {
		url: "select_request",
	};

	let data = {
		table: "accounting",
		method_type: "select_debt_transfers",
		data: payload?.data ? payload?.data : {},
		sort_by: {},
		size: "50",
		from: "0",
	};

	try {
		let res = yield AxiosCustom(config, data);
		let isOk = handleNotificationAlertTrySelect(res);
		yield put({
			type: actionTypes.selectDebtTransfers,
			payload: res.data.response,
		});
	} catch {
		handleNotificationAlertCatch();
		// yield put({ type: actionTypes.creaditSelectLoad, payload: false });
	} finally {
		yield put({ type: actionTypes.selectDebtTransfersLoad, payload: false });
	}
}

export function* selectDebtTransfers() {
	yield takeEvery(actionTypes.selectDebtTransfersAsync, handleWorker);
}
